"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Chart = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactResponsive = require("react-responsive");
var _reactI18next = require("react-i18next");
var _highcharts = _interopRequireDefault(require("highcharts"));
var _highchartsReactOfficial = _interopRequireDefault(require("highcharts-react-official"));
var _lodash = _interopRequireDefault(require("lodash.merge"));
var _utils = require("../../../utils");
var _theme = require("../../../theme");
var _getBalanceLabel = require("./getBalanceLabel");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var PIE_SIZE = 232;
var updateLegend = function updateLegend(chart, isSm) {
  if (!isSm) {
    var center = chart.series[0].center;
    chart.legend.group.attr({
      translateX: center[0] + center[2] / 2 + 20
    });
  }
};
var getSizeChart = function getSizeChart(chart, pieSize, isSm) {
  var _chart$legend;
  var _ref = (_chart$legend = chart.legend) !== null && _chart$legend !== void 0 ? _chart$legend : {},
    legendWidth = _ref.legendWidth,
    legendHeight = _ref.legendHeight;
  var heightChart = isSm ? pieSize + legendHeight + 30 : Math.max(pieSize, legendHeight) + 20;
  var widthChart = isSm ? Math.max(pieSize, legendWidth) + 20 : legendWidth + pieSize + 30;
  if (chart.chartHeight !== heightChart) {
    chart.setSize(widthChart, heightChart);
    updateLegend(chart, isSm);
  }
};
var Chart = function Chart(_ref2) {
  var balances = _ref2.balances,
    otherBalances = _ref2.otherBalances,
    _ref2$pieSize = _ref2.pieSize,
    pieSize = _ref2$pieSize === void 0 ? PIE_SIZE : _ref2$pieSize;
  var isSm = (0, _reactResponsive.useMediaQuery)({
    maxWidth: _utils.breakpoints.sm
  });
  var _useTranslation = (0, _reactI18next.useTranslation)('libCommon'),
    t = _useTranslation.t;
  var chartRef = (0, _react.useRef)(null);
  var _useReducer = (0, _react.useReducer)(function (x) {
      return x + 1;
    }, 0),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    force = _useReducer2[0],
    forceUpdate = _useReducer2[1];
  (0, _react.useEffect)(function () {
    if (chartRef.current && force) {
      getSizeChart(chartRef.current.chart, pieSize, isSm);
    }
  }, [chartRef.current, pieSize, isSm, force]);
  (0, _react.useEffect)(function () {
    window.addEventListener('resize', forceUpdate);
    return function () {
      return window.removeEventListener('resize', forceUpdate);
    };
  }, []);
  var data = balances.map(function (b) {
    return {
      label: (0, _getBalanceLabel.getBalanceLabel)(b, t),
      percent: b.percent
    };
  }).concat(otherBalances ? {
    label: (0, _getBalanceLabel.getBalanceLabel)(otherBalances, t),
    percent: otherBalances.percent
  } : []);
  var options = {
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      spacingBottom: 0,
      spacingTop: 0,
      events: {
        load: function load() {
          updateLegend(this, isSm);
        },
        redraw: function redraw() {
          getSizeChart(this, pieSize, isSm);
        }
      }
    },
    tooltip: {
      enabled: true,
      formatter: function formatter() {
        return data[this.point.index].label;
      }
    },
    title: {
      text: undefined,
      margin: 0
    },
    credits: {
      enabled: false
    },
    legend: _objectSpread(_objectSpread({}, isSm ? {
      align: 'center',
      verticalAlign: 'bottom'
    } : {
      align: 'right',
      verticalAlign: 'middle',
      layout: 'vertical'
    }), {}, {
      itemMarginBottom: 10,
      itemStyle: {
        fontSize: '14px',
        fontWeight: 400,
        fontFamily: 'Formular ,sans-serif'
      },
      symbolHeight: 12,
      symbolWidth: 12,
      labelFormatter: function labelFormatter() {
        return data[this.index].label;
      }
    }),
    plotOptions: {
      pie: {
        size: pieSize,
        dataLabels: {
          enabled: false
        },
        showInLegend: true,
        allowPointSelect: false,
        enableMouseTracking: true,
        states: {
          hover: {
            enabled: true
          }
        },
        point: {
          events: {
            legendItemClick: function legendItemClick() {
              return false;
            }
          }
        },
        colors: data === null || data === void 0 ? void 0 : data.map(function (el, i) {
          return _highcharts.default.color(_theme.theme.colors.purple).brighten(i / data.length / 2).get();
        })
      }
    },
    series: [{
      type: 'pie',
      data: data.map(function (el) {
        return ['', el.percent];
      }),
      borderWidth: 0,
      cursor: 'pointer'
    }]
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex justify-content-center"
  }, /*#__PURE__*/_react.default.createElement(_highchartsReactOfficial.default, {
    key: isSm ? 'mb' : 'desk',
    ref: chartRef,
    highcharts: _highcharts.default,
    options: data.length ? options : (0, _lodash.default)(options, {
      tooltip: {
        enabled: false
      },
      legend: {
        labelFormatter: function labelFormatter() {
          return t('holdings') + ': 0';
        }
      },
      plotOptions: {
        pie: {
          colors: [_theme.theme.colors.secondaryShade2],
          enableMouseTracking: false,
          states: {
            hover: {
              enabled: false
            }
          }
        }
      },
      series: [{
        data: [['', 100]]
      }]
    })
  }));
};
exports.Chart = Chart;